class TrSlider extends HTMLElement {
	selectors = {
		slide: '[data-tr-js-slider-slide]'
	};

	attributes = {
		config: 'data-tr-js-slider-config',
		legacyConfig: 'data-config'
	};

	stateClasses = {};

	config = {};

	slider = null;

	connectedCallback() {
		this.slideElements = [...this.querySelectorAll(this.selectors.slide)];

		this.init();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		document.removeEventListener('shopify:block:select', this.onBlockSelect);

		this.destroy();
	}

	init() {
		this.destroy();
		this.getConfig();

		if (typeof Swiper === 'undefined') return;

		this.slider = new Swiper(this, this.config);
	}

	onSectionLoad = event => {
		if (
			!this.closest(`#${event.detail.sectionId}`) &&
			!this.closest(`#shopify-section-${event.detail.sectionId}`)
		)
			return;

		this.init();
	};

	onBlockSelect = event => {
		if (!this.slider) return;

		const selectedSlideIndex = this.slideElements.findIndex(
			slideElement =>
				slideElement.dataset.trJsSliderSlide === event.detail.blockId
		);

		if (selectedSlideIndex === -1) return;

		if (this.slider.params.loop) {
			this.slider.slideToLoop(selectedSlideIndex);
			return;
		}

		this.slider.slideTo(selectedSlideIndex);
	};

	getConfig() {
		try {
			const config =
				this.getAttribute(this.attributes.config) ||
				this.getAttribute(this.attributes.legacyConfig);

			this.config = JSON.parse(config) || {};
		} catch (error) {
			console.error('Error parsing JSON:', error);
			this.config = {};
		}
	}

	destroy() {
		if (!this.slider) return;

		this.slider.destroy();

		this.slider = null;
	}
}

if (!customElements.get('tr-slider')) {
	customElements.define('tr-slider', TrSlider);
}
